import { APP_INFO_ACTION_TYPES } from '../actionTypes';

// reducer with initial state
const initialState = {
  info_loading: false,
  info: null,
  info_error: null,
};

const appInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case APP_INFO_ACTION_TYPES.GET.IN_PROGRESS:
      return { ...state, info_loading: true, info_error: null };
    case APP_INFO_ACTION_TYPES.GET.SUCCESS:
      return { ...state, info_loading: false, info: [...action.payload.apps] };
    case APP_INFO_ACTION_TYPES.GET.ERROR:
      return {
        ...state,
        info_loading: false,
        info: null,
        info_error: action.error,
      };
    default:
      return state; // return initial state by default
  }
};

export default appInfoReducer;
